// RitzyRa Hub design tokens — warm "Hand-Drawn / Journal" personality.
// Deep plum + charcoal with warm ochre/terracotta accents. Light + dark.
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const LIGHT = {
  surface: "#FDFBF7",
  onSurface: "#2D2A2B",
  surfaceSecondary: "#F4EFEA",
  onSurfaceSecondary: "#3A3638",
  surfaceTertiary: "#EAE3DD",
  onSurfaceTertiary: "#484345",
  surfaceInverse: "#2D2A2B",
  onSurfaceInverse: "#FDFBF7",
  muted: "#7A7376",

  brand: "#4A2B3D",
  onBrand: "#FDFBF7",
  brandPrimary: "#D4A373",
  onBrandPrimary: "#2D2A2B",
  brandSecondary: "#8B6B78",
  onBrandSecondary: "#FDFBF7",
  brandTertiary: "#DCC9D1",
  onBrandTertiary: "#4A2B3D",

  success: "#7A9E7E",
  onSuccess: "#FFFFFF",
  warning: "#E8B25C",
  onWarning: "#2D2A2B",
  error: "#B85C5C",
  onError: "#FFFFFF",
  info: "#7B96A6",
  onInfo: "#FFFFFF",

  border: "#E3D8D0",
  borderStrong: "#C2B2A7",
  divider: "#EAE3DD",
};

export const DARK = {
  surface: "#1C1719",
  onSurface: "#F1EAE6",
  surfaceSecondary: "#262023",
  onSurfaceSecondary: "#E3D9D3",
  surfaceTertiary: "#322A2E",
  onSurfaceTertiary: "#CFC3BC",
  surfaceInverse: "#F1EAE6",
  onSurfaceInverse: "#2D2A2B",
  muted: "#9A9095",

  brand: "#DCC9D1",
  onBrand: "#2D2A2B",
  brandPrimary: "#D4A373",
  onBrandPrimary: "#2D2A2B",
  brandSecondary: "#A98795",
  onBrandSecondary: "#1C1719",
  brandTertiary: "#3D2E37",
  onBrandTertiary: "#DCC9D1",

  success: "#8FB093",
  onSuccess: "#14210F",
  warning: "#E8B25C",
  onWarning: "#2D2A2B",
  error: "#D07E7E",
  onError: "#20100F",
  info: "#93AAB8",
  onInfo: "#10201F",

  border: "#3A3236",
  borderStrong: "#4E434A",
  divider: "#322A2E",
};

export const fonts = {
  display: 'Georgia, "Times New Roman", serif',
  text: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [scheme, setScheme] = useState(() => localStorage.getItem("ritzyra_scheme") || "light");

  useEffect(() => {
    localStorage.setItem("ritzyra_scheme", scheme);
    const colors = scheme === "dark" ? DARK : LIGHT;
    document.body.style.backgroundColor = colors.surface;
    document.documentElement.style.colorScheme = scheme;
  }, [scheme]);

  const value = useMemo(
    () => ({
      scheme,
      colors: scheme === "dark" ? DARK : LIGHT,
      toggle: () => setScheme((s) => (s === "dark" ? "light" : "dark")),
      setScheme,
    }),
    [scheme],
  );
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { scheme: "light", colors: LIGHT, toggle: () => {}, setScheme: () => {} };
  return ctx;
}
